export default [
    {
      path: '/admin/systems',
      name: 'system',
      meta: { requiresAuth: true },
      component: () => import('@/pages/setting/system/index.vue')
    }
  ]
